import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function invalidSymbolBuilder({parsedStatusObj}) {
  const actualSymbol = parsedStatusObj.actualSymbol;
  const expectedSymbol = parsedStatusObj.expectedSymbol;
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot complete action for symbol:
        {actualSymbol ? actualSymbol : 'N/A'}. Expected action for symbol:
        {expectedSymbol ? expectedSymbol : 'N/A'}.
      </Body3>
    </td>
  );
}
